import React from "react";
import useVABondForm from "../../../features/bonds/va/hooks/useVABondForm";
import BondWizardPageShell from "./BondWizardPageShell";
import { bondWizardPageConfig } from "./bondWizardPageConfig";

const VermostVABondRequestForm = () => {
  const form = useVABondForm();
  return (
    <BondWizardPageShell config={bondWizardPageConfig.va} form={form} />
  );
};

export default VermostVABondRequestForm;
